var map = {
	"./osmTagToNameMapping-cs.ts": [
		49358,
		8461
	],
	"./osmTagToNameMapping-de.ts": [
		75407,
		2788
	],
	"./osmTagToNameMapping-en.ts": [
		95463,
		1404
	],
	"./osmTagToNameMapping-hu.ts": [
		18587,
		8656
	],
	"./osmTagToNameMapping-it.ts": [
		15533,
		4654
	],
	"./osmTagToNameMapping-pl.ts": [
		55436,
		7127
	],
	"./osmTagToNameMapping-sk.ts": [
		14758,
		9077
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79837;
module.exports = webpackAsyncContext;